import * as React from 'react';
import { Crop } from '@foxbun/lib-goferal-types';
import { useEffect, useRef, useState } from 'react';
import Cropper, { ReactCropperElement } from 'react-cropper';
import styled from '@emotion/styled';
import 'cropperjs/dist/cropper.css';
import { Font } from '../../fonts';

export interface ImageUploadInputWidgetProps {
  changed: (file: File, crop?: Crop) => any;
  file: File;
  aspect_ratio?: number;
}

export const ImageUploadInputWidget: React.FC<ImageUploadInputWidgetProps> = (props) => {
  const [url, setUrl] = useState<string>();
  const cropperRef = useRef<ReactCropperElement>(null);

  useEffect(() => {
    if (props.file) {
      let url = URL.createObjectURL(props.file);
      setUrl(url);
      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setUrl(null);
      cropperRef.current?.cropper.destroy();
    }
  }, [props.file]);

  return (
    <S.Container>
      {url ? (
        <S.CropperContainer>
          <S.CropperWidget
            ref={cropperRef}
            aspectRatio={props.aspect_ratio ?? undefined}
            src={url}
            background={false}
            crop={() => {
              const { width, height, x, y } = cropperRef.current.cropper.getData();
              props.changed(props.file, {
                top: y,
                left: x,
                width: width,
                height: height
              });
            }}
            responsive={false}
            viewMode={2}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            guides={false}
          />
        </S.CropperContainer>
      ) : (
        <S.Center>
          <S.Text>Select image</S.Text>
          <S.Input
            type="file"
            onChange={(event) => {
              props.changed(event.target.files.item(0), null);
            }}
          />
        </S.Center>
      )}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    aspect-ratio: 1 / 1;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    border: solid 1px ${(p) => p.theme.forms.border};
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  `;

  export const Center = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  `;

  export const Text = styled.div`
    color: ${(p) => p.theme.forms.label};
    font-family: ${Font.Normal};
  `;

  export const Input = styled.input`
    opacity: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  `;

  export const CropperContainer = styled.div`
    background: white;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  `;

  export const CropperWidget = styled(Cropper)`
    flex-grow: 1;
  `;
}
